import { createSlice } from '@reduxjs/toolkit';
import { contractorApi } from '@store/rtk/contractors';
import { selectItemType } from '@src/types';

type ContractorTagsType = {
  rideAllTags: Array<selectItemType>;
  rideSelectedTags: Array<selectItemType>;
  addonAllTags: Array<selectItemType>;
  addonSelectedTags: Array<selectItemType>;
};

const initialState: ContractorTagsType = {
  rideAllTags: [],
  rideSelectedTags: [],
  addonAllTags: [],
  addonSelectedTags: [],
};

export const tagsSlice = createSlice({
  name: 'contractorTags',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      contractorApi.endpoints.getContractorRideAllTags.matchFulfilled,
      (state, { payload }) => {
        if (payload && Array.isArray(payload)) {
          state.rideAllTags = [...payload];
        }
      }
    );
    builder.addMatcher(
      contractorApi.endpoints.getContractorRideSelectedTags.matchFulfilled,
      (state, { payload }) => {
        if (payload && Array.isArray(payload)) {
          state.rideSelectedTags = [...payload];
        }
      }
    );
    builder.addMatcher(
      contractorApi.endpoints.getContractorAddonAllTags.matchFulfilled,
      (state, { payload }) => {
        if (payload && Array.isArray(payload)) {
          state.addonAllTags = [...payload];
        }
      }
    );
    builder.addMatcher(
      contractorApi.endpoints.getContractorAddonSelectedTags.matchFulfilled,
      (state, { payload }) => {
        if (payload && Array.isArray(payload)) {
          state.addonSelectedTags = [...payload];
        }
      }
    );
  },
});

export const selectContractorTags = (state: {
  contractorTags: ContractorTagsType;
}) => state.contractorTags;
export const tagsReducer = tagsSlice.reducer;
